// extracted by mini-css-extract-plugin
export default {"heading":"kD8JhVxIQvBM5a14ePWA"};
    if(module.hot) {
      // 1647894309304
      var cssReload = require("../node_modules/mini-css-extract-plugin/dist/hmr/hotModuleReplacement.js")(module.id, {"locals":true});
      module.hot.dispose(cssReload);
      
    }
  